/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type Transition from '@ember/routing/-private/transition';
import { hash } from 'rsvp';
import type IntlService from 'embercom/services/intl';
import { ReactRoute } from 'embercom/lib/react-route';

const OPERATOR_SETTINGS_PERMISSION = 'can_create_and_edit_bots';
const PRODUCT_SETTINGS_PERMISSION = 'can_access_product_settings';

class FinAIAgentSettingsRoute extends IntercomRoute {
  @service declare appService: AppService;
  @service declare intercomEventService: any;
  @service declare permissionsService: any;
  @service declare store: Store;
  @service declare intl: IntlService;

  reactEnabled() {
    return window.location.search.includes('reactEnabled');
  }

  analytics = {
    section: 'ai-chatbot',
    place: 'settings',
  };

  get titleToken(): string {
    return this.intl.t('ai-agent.sub-menu.settings.title');
  }

  beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning(
      OPERATOR_SETTINGS_PERMISSION,
      transition,
    );
    this.permissionsService.ensurePermissionWhenTransitioning(
      PRODUCT_SETTINGS_PERMISSION,
      transition,
    );
  }

  async model() {
    let appId = this.appService.app.id;
    let messengerSettings = await this.store.findRecord('messenger-settings/all', appId);
    let multilingualSettings = await this.getMultilingualSettings();

    return hash({
      previewConfiguration: messengerSettings.previewConfiguration,
      aiAgentSettings: this.store.findRecord('ai-agent/settings', appId),
      aiAgentToneOfVoiceSettings: this.store.findRecord('ai-agent/tone-of-voice-settings', appId),
      aiAgentQuickReplySettings: this.store.findRecord(
        'operator-settings/ai-agent-quick-replies',
        appId,
      ),
      aiAgentMultilingualSettings: multilingualSettings,
      aiAgentEmailResponsesSettings: this.store.findRecord(
        'ai-agent/email-responses-settings',
        appId,
      ),
      languages: messengerSettings.languages,
      conversationImports: this.store.findAll('conversation-import'),
    });
  }

  async getMultilingualSettings(): Promise<$TSFixMe> {
    return this.store.findRecord('ai-agent/multilingual-settings', this.appService.app.id);
  }
}
export default ReactRoute(FinAIAgentSettingsRoute);
